export interface ModalClient {
	render(container: HTMLElement): void;
	canClose(): boolean;
}

export class ModalHost {
	private static isActive: boolean = false;
	private static modalBackground: HTMLElement;
	private static childContainer: HTMLElement;
	private static oldOverflow: string | null;

	public static displayModal(modalClient: ModalClient) {
		if(ModalHost.isActive) {
			return;
		}

		ModalHost.isActive = true;

		const background = document.createElement("div");
		background.id = "modalHost_background";
		background.addEventListener("click", () => ModalHost.tryClose());
		document.body.appendChild(background);
		ModalHost.modalBackground = background;

		const childContainer = document.createElement("div");
		childContainer.id = "modalHost_childContainer";
		childContainer.addEventListener("click", () => ModalHost.tryClose());
		document.body.appendChild(childContainer);
		ModalHost.childContainer = childContainer;

		
		//this.oldOverflow = document.body.style.overflow;
		//document.body.style.overflow = "hidden";
		//this.oldOverflow = document.documentElement.style.overflow;
		//document.documentElement.style.overflow = "hidden";

		modalClient.render(childContainer);
	}

	public static shouldScroll(): boolean {
		return ModalHost.isActive;
	}

	public static tryClose() {
		ModalHost.modalBackground.parentElement!.removeChild(ModalHost.modalBackground);
		ModalHost.childContainer.parentElement!.removeChild(ModalHost.childContainer);
		document.documentElement.style.overflow = this.oldOverflow;
		ModalHost.isActive = false;
	}
}